<kp-privacy-full [fromScreen]="fromScreen"></kp-privacy-full>
